import {PRODUCT_CHAIN_PATH,PRODUCT_STOCK_PATH,MARS_CORE_SERVER_PATH,PRODUCT_REPORT_PATH}from'@monorepo/shared';import HttpRequest from'../../http/index.js';/*
 * @Author: 朱浩
 * @Date: 2023-05-17 16:59:31
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-11-11 15:48:09
 * @Description: 过滤商品的接口
 */
/** 查询 */
const filterList = (data) => HttpRequest({
    url: `${PRODUCT_CHAIN_PATH}/finished_product_saved_searches.json`,
    data: data,
});
/** 创建 */
const filterCreate = (data) => HttpRequest({
    url: `${PRODUCT_CHAIN_PATH}/finished_product_saved_searches.json`,
    data: data,
    method: 'POST',
});
/** 更新 */
const filterUpdate = (data) => HttpRequest({
    url: `${PRODUCT_CHAIN_PATH}/finished_product_saved_searches/${data.id}.json`,
    data: data,
    method: 'PUT',
});
/** 删除 */
const filterDelete = (id) => HttpRequest({
    url: `${PRODUCT_CHAIN_PATH}/finished_product_saved_searches/${id}.json`,
    method: 'DELETE',
});
// 生成Url前缀
const generateUrlPrefix = (service) => {
    let url = PRODUCT_CHAIN_PATH;
    if (service === 'stock') {
        url = PRODUCT_STOCK_PATH;
    }
    else if (service === 'core') {
        url = MARS_CORE_SERVER_PATH;
    }
    else if (service === 'report') {
        url = PRODUCT_REPORT_PATH;
    }
    return url;
};
// 生成url隔断符号
const generateUrlSeparator = (service) => {
    let separator = '/';
    if (service === 'report') {
        separator = '_';
    }
    return separator;
};
/** 查询 */
const generalFilterList = (key, data, service) => HttpRequest({
    url: `${generateUrlPrefix(service)}/${key.toLowerCase()}${generateUrlSeparator(service)}saved_searches.json`,
    data: data,
});
/** 创建 */
const generalFilterCreate = (key, data, service) => HttpRequest({
    url: `${generateUrlPrefix(service)}/${key.toLowerCase()}${generateUrlSeparator(service)}saved_searches.json`,
    data: data,
    method: 'POST',
});
/** 更新 */
const generalFilterUpdate = (key, data, service) => HttpRequest({
    url: `${generateUrlPrefix(service)}/${key.toLowerCase()}${generateUrlSeparator(service)}saved_searches/${data.id}.json`,
    data: data,
    method: 'PUT',
});
/** 删除 */
const generalFilterDelete = (key, id, service) => HttpRequest({
    url: `${generateUrlPrefix(service)}/${key.toLowerCase()}${generateUrlSeparator(service)}saved_searches/${id}.json`,
    method: 'DELETE',
});export{filterCreate,filterDelete,filterList,filterUpdate,generalFilterCreate,generalFilterDelete,generalFilterList,generalFilterUpdate};//# sourceMappingURL=filter.services.js.map
